import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { JourneyDetail } from "./types";

// GET /api/admin/journeys/:id → JourneyDetail
//
// Sub-bucket 14. Aggregate: journey row + ordered task list + assignment
// count. Phase 6 bucket-11 mutation hooks already patch this cache key
// optimistically (e.g. useReorderTasks, useUpdateTask), so the builder
// page can rely on the cache being up-to-date without re-fetching after
// each mutation.
export function useJourney(id: string | undefined) {
  return useQuery<JourneyDetail, ApiClientError>({
    queryKey: id
      ? queryKeys.journeys.detail(id)
      : ["journeys", "detail", "__missing__"],
    queryFn: () => apiFetch<JourneyDetail>(`/admin/journeys/${id}`),
    enabled: !!id,
  });
}
